/**
 * Custom hook to ensure Flask authentication is available
 */

import { useEffect, useState } from 'react';
import FlaskAuthService from '../services/flaskAuthService';

interface UseEnsureFlaskAuthReturn {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  retry: () => void;
}

export const useEnsureFlaskAuth = (): UseEnsureFlaskAuthReturn => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const authenticate = async () => {
    setIsLoading(true);
    setError(null);

    try {
      await FlaskAuthService.ensureToken();
      setIsAuthenticated(true);
      console.log('[useEnsureFlaskAuth] Authentication successful');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Authentication failed';
      setError(errorMessage);
      setIsAuthenticated(false);
      console.error('[useEnsureFlaskAuth] Authentication failed:', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    authenticate();
  }, []);

  return {
    isAuthenticated,
    isLoading,
    error,
    retry: authenticate,
  };
};

export default useEnsureFlaskAuth;
